import { FC, memo } from 'react';

import {
    BaseCurrency,
    InputWrapper,
    Root,
    SelectedCurrencyWrapper,
    StyledNumberEditor,
} from './CurrencyExchangeRateInput.styles';
import { CurrencyExchangeRateInputProps } from './CurrencyExchangeRateInput.types';

const CurrencyExchangeRateInput: FC<CurrencyExchangeRateInputProps> = (props) => {
    const {
        defaultCurrency,
        selectedCurrency,
        exchangeRateValue,
        variant = 'inline',
        max = 10000000,
        precision = 6,
        onExchangeRateChange,
        disabled = false,
        className,
        showValidationErrors,
        required,
        warning,
    } = props;

    if (!defaultCurrency || !selectedCurrency) {
        return null;
    }

    return (
        <Root className={className} $variant={variant}>
            <BaseCurrency $variant={variant}>1 {defaultCurrency.id} =</BaseCurrency>

            <InputWrapper>
                <StyledNumberEditor
                    allowFloat
                    min={0}
                    max={max}
                    precision={precision}
                    value={exchangeRateValue}
                    $variant={variant}
                    onChange={onExchangeRateChange}
                    disabled={disabled}
                    warning={warning}
                    invalid={showValidationErrors && required && !exchangeRateValue}
                />

                <SelectedCurrencyWrapper $variant={variant}>{selectedCurrency.id}</SelectedCurrencyWrapper>
            </InputWrapper>
        </Root>
    );
};

export default memo(CurrencyExchangeRateInput);
